module.exports = __webpack_public_path__ + "static/media/icon-zoom.f811bd6b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-zoom.svg
// module id = 321
// module chunks = 0